import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';

import { QuillModule } from 'ngx-quill';

import { MentionsModule } from '@app/src/app/mentions';

import { MgQuillEditor } from './QuillEditor.component';

@NgModule({
  imports: [
    // Minga dependencies
    MentionsModule,

    // External dependencies
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    QuillModule,
  ],
  declarations: [MgQuillEditor],
  exports: [MgQuillEditor],
})
export class MgQuillEditorModule {}
